var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddWorkflow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      zoom: 1.3
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8C17.1193 8 16 6.88071 16 5.5C16 4.11929 17.1193 3 18.5 3C19.8807 3 21 4.11929 21 5.5C21 6.88071 19.8807 8 18.5 8ZM18.5 8C18.5 8 18.5 8.87581 18.5 12M5.5 16V8.7C5.5 7.5799 5.5 7.01984 5.718 6.59202C5.9097 6.21569 6.2157 5.90973 6.592 5.71799C7.0198 5.5 7.5799 5.5 8.7 5.5H12M5.5 16C4.1193 16 3 17.1193 3 18.5C3 19.8807 4.1193 21 5.5 21C6.8807 21 8 19.8807 8 18.5C8 17.1193 6.8807 16 5.5 16ZM12 5.5L9.5 8M12 5.5L9.5 3",
    stroke: "#10A37F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.596V21.798C16 22.2388 16.3574 22.596 16.798 22.596C17.2385 22.5958 17.5949 22.2385 17.5949 21.798V19.596H19.798C20.2385 19.5958 20.5949 19.2385 20.5949 18.798C20.5949 18.3575 20.2385 18.0002 19.798 18H17.5949V15.798C17.5949 15.3575 17.2385 15.0002 16.798 15C16.3574 15 16 15.3572 16 15.798V18H13.798C13.3574 18 13 18.3572 13 18.798C13 19.2388 13.3574 19.596 13.798 19.596H16Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddWorkflow);
export default __webpack_public_path__ + "static/media/icon-add-workflow.01c0f0edd8247f4f00b33b338237ff6e.svg";
export { ForwardRef as ReactComponent };